// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","title":"_3EA5WaRnkagKlal7TiNj88 _2IbHD4FVxtBnbNHEUw2mS3","container":"_3woYCvghE1vFiItYbcM7TL","videoList":"_1PSclBcFgNRmCxNGtuQm8e","video":"_2VDfY3nKdMZEeu9YfN9yxx"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/product-detail/videos-section/VideosSection.css
// module id = 1041
// module chunks = 1